module.exports = __webpack_public_path__ + "static/media/CrushedCorner_After.0307cecf.jpg";